module.exports = __webpack_public_path__ + "static/img/5h.0197a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5h.jpg
// module id = dOeU
// module chunks = 0